import { render } from "./SortDropdownItem.vue?vue&type=template&id=526bcb30&scoped=true"
import script from "./SortDropdownItem.vue?vue&type=script&lang=js"
export * from "./SortDropdownItem.vue?vue&type=script&lang=js"

import "./SortDropdownItem.vue?vue&type=style&index=0&id=526bcb30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526bcb30"]])

export default __exports__